import styled from 'styled-components';

export const Container = styled.input`
  border: none;
  border-radius: 5px;
  padding: 10px;
  font-size: 14px;
  background-color: #EFEFEF;
  font-weight: 700;
  color: #333;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;